import { Theme } from '@mui/material/styles';

export const EVENTOS_WIDTH = 0;
export interface HeaderConfig {
  field: string;
  label: string;
  sticky?: boolean;
  width?: number;
  render?: (row: any) => React.ReactNode;
}

const cellSx = (isHeader = false) => ({
  backgroundColor: 'background.paper',
  whiteSpace: 'nowrap' as const,
  ...(!isHeader && {
    '.MuiTableRow-root:hover &': {
      backgroundColor: (theme: any) => {
        const bg = theme.palette.background.paper;
        const overlayBase = theme.palette.mode === 'dark' ? '#fff' : '#000';
        const pct = Math.round(theme.palette.action.hoverOpacity * 100);
        // Ambas as cores são opacas → resultado 100% opaco
        return `color-mix(in srgb, ${bg} ${100 - pct}%, ${overlayBase})`;
      },
    },
  }),
});

export const getStickyProps = (headers: HeaderConfig[], index: number, isHeader = false) => {
  const col = headers[index];
  
  if (!col.sticky) return cellSx(isHeader);

  let left = EVENTOS_WIDTH;
  for (let i = 0; i < index; i++) {
    if (headers[i].sticky) left += headers[i].width ?? 0;
  }

  return {
    ...cellSx(isHeader),
    position: 'sticky' as const,
    left,
    zIndex: isHeader ? 4 : 2,
    minWidth: col.width,
  };
};

export const getBaseCellProps = cellSx;
export const ACOES_WIDTH = 120;

// Use na coluna "Ações" (sticky à direita) — evita rolar a tabela em telas pequenas
export const getStickyRightProps = (isHeader = false, width: number = ACOES_WIDTH) => ({
  ...cellSx(isHeader),
  position: 'sticky' as const,
  right: 0,
  zIndex: isHeader ? 4 : 2,
  width,
  minWidth: width,
});

export const getHighlightCellProps = () => ({
  backgroundColor: (theme: Theme) => {
    const bg = theme.palette.background.paper;
    const overlayBase = theme.palette.mode === 'dark' ? '#fff' : '#000';
    const pct = Math.round(theme.palette.action.selectedOpacity * 100);
    return `color-mix(in srgb, ${bg} ${100 - pct}%, ${overlayBase})`;
  },
});
